/* ===== 2026-11-02: catalogue-linked openness and colour selection ===== */
(() => {
  'use strict';
  function initialise(root) {
    if (root.dataset.zyPickerReady) return;
    root.dataset.zyPickerReady = 'true';
    const opens = [...root.querySelectorAll('[data-zy-open]')];
    const panels = [...root.querySelectorAll('[data-zy-colour-panel]')];
    const count = root.querySelector('[data-zy-colour-count]');
    const summary = root.querySelector('[data-zy-selected-colour]');
    const code = root.querySelector('[data-zy-selected-code]');
    const source = root.querySelector('[data-zy-catalogue-link]');
    const remembered = new Map();
    function selectColour(panel, swatch) {
      panel.querySelectorAll('[data-zy-colour-code]').forEach(button => {
        button.setAttribute('aria-pressed', String(button === swatch));
      });
      remembered.set(panel.dataset.zyColourPanel, swatch.dataset.zyColourCode);
      summary.textContent = `${panel.dataset.zyColourPanel}% · ${swatch.dataset.zyColourName}`;
      code.textContent = swatch.dataset.zyColourCode;
      root.dataset.selectedOpenness = panel.dataset.zyColourPanel;
      root.dataset.selectedColour = swatch.dataset.zyColourCode;
    }
    function selectOpen(value) {
      const panel = panels.find(item => item.dataset.zyColourPanel === value);
      if (!panel) return;
      opens.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.zyOpen === value)));
      panels.forEach(item => { item.hidden = item !== panel; });
      const swatches = [...panel.querySelectorAll('[data-zy-colour-code]')];
      const swatch = swatches.find(item => item.dataset.zyColourCode === remembered.get(value)) || swatches[0];
      selectColour(panel, swatch);
      count.textContent = `${swatches.length} catalogue colour${swatches.length === 1 ? '' : 's'}`;
      source.href = `https://www.longshade.sg/pages/catalog#page-${panel.dataset.cataloguePage}`;
    }
    root.addEventListener('click', event => {
      const open = event.target.closest('[data-zy-open]');
      if (open && root.contains(open)) { selectOpen(open.dataset.zyOpen); return; }
      const colour = event.target.closest('[data-zy-colour-code]');
      if (colour && root.contains(colour)) selectColour(colour.closest('[data-zy-colour-panel]'), colour);
    });
    selectOpen(root.dataset.defaultOpenness || '5');
  }
  function boot(scope = document) { scope.querySelectorAll('[data-zy-fabric-picker]').forEach(initialise); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
